import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BackendService } from 'src/app/services/backend.service';
import { Router,NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-timeline',
  templateUrl: './timeline.component.html',
  styleUrls: ['./timeline.component.scss']
})
export class TimelineComponent implements OnInit {
  public pushRightClass: string;


  constructor(private translate: TranslateService,private backendService: BackendService  , private router:Router) {  
    this.translate.use(window.localStorage.getItem('idioma'));
    this.translate.addLangs(['es','pt']);
    this.router.events.subscribe(val => {
      if (
          val instanceof NavigationEnd &&
          window.innerWidth <= 992 &&
          this.isToggled()
      ) {
          this.toggleSidebar();
      }
  });
}

isToggled(): boolean {
  const dom: Element = document.querySelector('body');
  return dom.classList.contains(this.pushRightClass);
}
toggleSidebar() {
  const dom: any = document.querySelector('body');
  dom.classList.toggle(this.pushRightClass);
}
  ngOnInit() {
  }

}
